import { defineComponent as _defineComponent } from 'vue'
import SelectableArea from '@/components/SelectableArea.vue'

// import { CtInventoryLocation } from '@/models/interfaces/content-type'
import { InventoryLocationPosition } from './WarehouseMap'
import { ref } from 'vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'WarehouseMap',
  props: {
    locations: { default: () => [] }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();


const props = __props

const points = ref(Array(500).fill(0))


const __returned__ = { props, points, SelectableArea, get InventoryLocationPosition() { return InventoryLocationPosition }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})